import { IBlocklistAllowlistItem } from '../../entities/blocklist-allowlist-constants';
import { useQuery } from 'react-query';
import { IResponse } from 'utils/queryResponse';
import { getBlocklistAllowlist } from '../../queries/getBlocklistAllowlist';

export const useBlocklistAllowlist = (siteId: string, queryString: string): IResponse<IBlocklistAllowlistItem[]> => {
  const query = {
    queryKey: ['allowlist', siteId, queryString],
    queryFn: () => getBlocklistAllowlist(siteId, queryString),
  };
  const results = useQuery(query);
  const isError = results.isError;
  const isLoading = results.isLoading;
  const isSuccess = results.isSuccess;
  const hasData = !!results.isSuccess;
  return {
    data: (results?.data ?? []) as IBlocklistAllowlistItem[],
    isError,
    isLoading,
    isSuccess,
    hasData,
  };
};
